/* global globalThis */
import React, {useContext, useEffect, useState} from "react";
import PropTypes from "prop-types";
import {useLocation} from "react-router-dom";
import {Helmet} from "react-helmet";
import {LAST_QUERY_USAGE_KEY} from "../patientProfile/PatientProfileHeader";
import {Badge, Card, Col, Container, Dropdown, Row} from "react-bootstrap";

import ExportSummary from "./ExportSummary";

import ListView from "./components/patientList";
import CustomPagination from "../common/CustomPaginaton";
import SpinnerLoading from "../common/components/spinner";

import {
    cancelRequest,
    removePatientsFromList,
    searchPatientMain,
    searchPatientMultiple,
} from "../../actions/patientSearch/patientSearchActions";
import {FilterParam, PatientSearchDTO} from "../../dtos/PatientSearchDTO";
import axios from "../../utils/apiClient";
import Modals from "../../components/modals";
import {
    formatDate,
    getCustomListName,
    getCustomWorklistName,
    getPatientProfileLink,
    getQuickListId,
    preventiveCarePatientFilterParams,
} from "../../utils/util";
import _ from "lodash";
import {AppPropertiesUtil, SessionStorageUtil} from "../../utils/localStorageUtil";
import {QuickListContext} from "./QuickListContext";
import {CE_RESTORE_OBJ} from "../common/MainLayout";

import {FilterGroupNew} from "../../components/filters/filterGroupNew";

const isEmpty = require("is-empty");

export const PRINT_URL = process.env.REACT_APP_REST_API_BASE_URL + "/v1/patient-card/print";
export const PRINT_SYNC_URL = process.env.REACT_APP_REST_API_BASE_URL + "/v1/patient-card/print-sync";
export const EXPORT_URL = process.env.REACT_APP_REST_API_BASE_URL + "/v1/patient-card/export";
export const SUMMARY_URL = process.env.REACT_APP_REST_API_BASE_URL + "/v1/patient-card/export-summary";
export const CUSTOM_LIST_URL = process.env.REACT_APP_REST_API_BASE_URL + "/v1/custom-filtered-list/custom-lists";
export const WORKLIST_URL = process.env.REACT_APP_REST_API_BASE_URL + "/v1/custom-work-list/work-list";
const LAST_QUERY_SETTINGS_SUFFIX = `-QLQuerySettings`;
const RECENT_QUERY_SETTINGS_KEY = `ce-recent-query-settings-key`;

const pathName = globalThis.location.pathname;
const modifiedPathName = pathName.endsWith("/") ? pathName.substring(0, pathName.length - 1) : pathName;
export const RETURN_TO_MY_PATIENTS_URL = encodeURIComponent(
  "returnTo_" + modifiedPathName + "?loadLastQuerySettings=true"
);

const componentName = "QuickList";
const MISSED_OPPORTUNITIES_STATUS_MAPPING = {
  AWAITING_CHART: "awaitingChart",
  REJECTED: "rejected",
};
const hasNumericQuicklistId = (id) => id && !Number.isNaN(Number(id));
const getPageObjArr = (selectedValues, mapping) => selectedValues.map((value) => mapping[value]).filter(Boolean);

const RemoveModalBody = ({ patientsSelected }) => {
  const location = useLocation();

  return (
    <div>
      <span>
        You have selected {patientsSelected.length} member
        {patientsSelected.length > 1 && "s"} to remove from your organiazation's patient list.
      </span>
      <br />
      <br />
      <span>Would you like to proceed?</span>
      <br />
      {patientsSelected.map((patient, index) => (
        <a
          key={patient.id ?? `${patient.lastName}-${patient.firstName}-${index}`}
          className="nav-link pt-0 pb-0"
          href={getPatientProfileLink(patient.id, location, "PreventiveCare")}
        >
          {patient.lastName}, {patient.firstName}
        </a>
      ))}
    </div>
  );
};

RemoveModalBody.propTypes = {
  patientsSelected: PropTypes.arrayOf(
    PropTypes.shape({
      firstName: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      lastName: PropTypes.string,
    })
  ).isRequired,
};

const VIEW = { card: "CARD", list: "LIST" };

const QuickLists = ({
  titleProp,
  filters,
  pageNumberProp,
  pageSizeProp,
  totalSizeProp,
  defaultFilterParamsProp,
  defaultSortParamsProp,
  exportPatientsUrl,
  quickListType,
  displayExtraRows,
  quickListId,
  cardViewActionObj = {
    fetchData: searchPatientMain,
    copyMap: {
      list: "patientCardDtos",
      totalSize: "totalSize",
      pageSize: "pageSize",
      pageNumber: "pageNumber",
    },
  },
  unScheduledActionObj = {
    fetchData: searchPatientMain,
    copyMap: {
      list: "patientCardDtos",
      totalSize: "totalSize",
      pageSize: "pageSize",
      pageNumber: "pageNumber",
    },
  },
  listViewActionObj,
  startingView = VIEW.card,
  listViewColumns,
  careManagementActions,
}) => {
  const qlsSettings = useContext(QuickListContext);
  let quicklistId = getQuickListId();
  let customWorklistName = getCustomWorklistName();
  let customListName = getCustomListName();
  useEffect(() => {
    const location = globalThis.location.pathname;
    let workingPathName = location.endsWith("/") ? location.substring(0, location.length - 1) : location;
    if (hasNumericQuicklistId(quicklistId)) {
      setReturnToMyPatientsUrl(
        encodeURIComponent(
          "returnTo_" +
            workingPathName +
            encodeURIComponent("?loadLastQuerySettings=true&id=" + quicklistId + "&customListName=" + customListName)
        )
      );
    } else {
      setReturnToMyPatientsUrl(encodeURIComponent("returnTo_" + workingPathName + "?loadLastQuerySettings=true"));
    }
  }, [quickListType, quicklistId, customListName]);

  const [returnToMyPatientsUrl, setReturnToMyPatientsUrl] = useState(RETURN_TO_MY_PATIENTS_URL);
  const [selectedPatients, setSelectedPatients] = useState(new Map());
  const [title, setTitle] = useState(titleProp);
  const [patientsList, setPatientsList] = useState({
    awaitingChart: [],
    rejected: [],
  });
  const [cardViewData, setCardViewData] = useState({});
  const [listViewData, setListViewData] = useState({});
  const [pageNumber, setPageNumber] = useState(pageNumberProp);
  const [pageSize, setPageSize] = useState(pageSizeProp);
  const [totalSize, setTotalSize] = useState(totalSizeProp);
  const [filterApplied, setFilterApplied] = useState(true);
  const [multipleFilterApplied, setMultipleFilterApplied] = useState(false);



  const [awaitingChartPatientSize, setAwaitingChartPatientSize] = useState({});
  const [rejectedPatientSize, setRejectedPatientSize] = useState({});




  const [loadingData, setLoadingData] = useState(true);
  const [listViewLoadingData, setListViewLoadingData] = useState(Boolean(listViewActionObj));

  const [defaultFilterParams, setDefaultFilterParams] = useState(defaultFilterParamsProp);
  const [filterParams, setFilterParams] = useState(defaultFilterParamsProp);
  const [sortParams, setSortParams] = useState([]);
  const [modalMessage, setModalMessage] = useState(null);
  const [removeModal, setRemoveModal] = useState(false);
  const [modalSize, setModalSize] = useState(null);
  const [modalTitle, setModalTitle] = useState(null);
  const [showPrintSpinner, setShowPrintSpinner] = useState(false);
  const [showExportSpinner, setShowExportSpinner] = useState(false);
  const [view, setView] = useState(startingView);
  const [canceled, setCanceled] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const activeFilterView = "";

  const LAST_QUERY_SETTINGS_KEY = `${quickListType}` + LAST_QUERY_SETTINGS_SUFFIX;
  const PRINT_THRESHOLD = AppPropertiesUtil.get("export.download.limit");

  const setDefaultFilterParamHelper = (filterParams) => {
    setDefaultFilterParams(defaultFilterParamsProp);
    setFilterParams(filterParams);
  };



  const handleFilterChange = (filterParams, p) => {
    cancelRequest(setCanceled);
    setFilterParams(filterParams);
    setSelectedPatients(new Map());
    if (!p) {
      p = 1;
    }
    query(new PatientSearchDTO(filterParams, sortParams, p, pageSize, quickListType, totalSize), title, view);
  };

  const handleFilterPageSize = (e) => {
    const result = e.target.value.split("-");
    query(new PatientSearchDTO(filterParams, sortParams, 1, result[0], quickListType, totalSize), title, view);
  };

  const handlePaginationChange = (pageNumber) => {
    setPageNumber(pageNumber);
    query(new PatientSearchDTO(filterParams, sortParams, pageNumber, pageSize, quickListType, totalSize), title, view);
  };
  const handlePatientGapStatusChange = () => {
    query(new PatientSearchDTO(filterParams, sortParams, pageNumber, pageSize, quickListType), title, view);
  };

  let pageObject = {
    pageNumber: 0,
    data: {},
    awaitingChart: {},
    rejected: {}
  };

  const copyToPatientListVariables = (
    data,
    awaitingChart,
    rejected,
    inView
  ) => {
    let copyMap = null;
    if (!inView) {
      inView = view;
    }
    if (inView === VIEW.card || (inView === VIEW.list && !listViewActionObj)) {
      copyMap = cardViewActionObj.copyMap;
    } else if (inView === VIEW.list && listViewActionObj) {
      copyMap = listViewActionObj.copyMap;
    }
    setTotalSize(_.get(data, copyMap["totalSize"]));
    setPageSize(_.get(data, copyMap["pageSize"]));
    setPageNumber(_.get(data, copyMap["pageNumber"]));
    let patientListSectioned = {
      awaitingChart: [],
      rejected: []
      ,
    };
    let totalSize = 0;
    if (quickListType === "MISSED_OPPORTUNITIES") {
      patientListSectioned.awaitingChart = _.get(awaitingChart, copyMap["list"]);
      if (totalSize < _.get(awaitingChart, copyMap["totalSize"])) {
        totalSize = _.get(awaitingChart, copyMap["totalSize"]);
        setPageSize(_.get(awaitingChart, copyMap["pageSize"]));
        setPageNumber(_.get(awaitingChart, copyMap["pageNumber"]));
        setTotalSize(totalSize);
      }
      setAwaitingChartPatientSize(_.get(awaitingChart, copyMap["totalSize"]));
      patientListSectioned.rejected = _.get(rejected, copyMap["list"]);
      if (totalSize < _.get(rejected, copyMap["totalSize"])) {
        totalSize = _.get(rejected, copyMap["totalSize"]);
        setPageSize(_.get(rejected, copyMap["pageSize"]));
        setPageNumber(_.get(rejected, copyMap["pageNumber"]));
        setTotalSize(totalSize);
      }
      setRejectedPatientSize(_.get(rejected, copyMap["totalSize"]));

    } else {
      patientListSectioned.default = _.get(data, copyMap["list"]);
    }
    setPatientsList(patientListSectioned);
    setPageCount(
      _.get(data, copyMap["totalSize"]) +
      _.get(rejected, copyMap["totalSize"]) +
      _.get(awaitingChart, copyMap["totalSize"]));
  };

  useEffect(() => {
    if (cardViewData && cardViewData.pageNumber === pageNumber) {
      if (!listViewActionObj) {
        setListViewData(cardViewData);
        copyToPatientListVariables(

          cardViewData.data,
          cardViewData.awaitingChart,
          cardViewData.rejected

        );
      } else if (listViewActionObj && view === VIEW.card) {
        copyToPatientListVariables(
          cardViewData.data,
          cardViewData.awaitingChart,
          cardViewData.rejected
        );
      }
      setLoadingData(false);
    }
  // Card response hydration is intentionally keyed to the response payload only.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardViewData]);

  const callworklistquery = async (patientSearchDTO, updatedTitle, updatedView, filterApplied, paramValue, multipleFilterApplied) => {
    let emptyResponse = {
      patientCardDtos: [],
      pageNumber: patientSearchDTO.pageNumber,
      pageSize: 20,
      totalSize: 0,
    };
    pageObject.data = emptyResponse;
    let pageObjArr;
    let values;
    pageObjArr = ["awaitingChart", "rejected"];
    values = ["AWAITING_CHART", "REJECTED"];
    if (filterApplied) {
      values = paramValue;
      pageObjArr = getPageObjArr(values, MISSED_OPPORTUNITIES_STATUS_MAPPING);
      pageObjArr.forEach((filter) => {
        setSelectedFilter((prevState) => [...prevState, filter]);
      })
    } else {
      setFilterApplied(false);
    }
    const allWorklistsCall = values.map((value, index) =>
      createParamObjectForWorklist(
        patientSearchDTO,
        updatedTitle,
        updatedView,
        filterApplied,
        value,
        pageObjArr[index],
        multipleFilterApplied
      )
    );
    cancelRequest(setCanceled);
    await searchPatientMultiple(allWorklistsCall, 'searchMissedOpportunitiesQL')
      .then((res) => {
        if (res.data) {
          pageObject.pageNumber = patientSearchDTO.pageNumber;
          pageObject.awaitingChart = res.data["AWAITING_CHART"] ? res.data["AWAITING_CHART"] : emptyResponse;
          pageObject.rejected = res.data["REJECTED"] ? res.data["REJECTED"] : emptyResponse;
          setCardViewData(pageObject);
        }
      })
        .catch(() => {
          setLoadingData(false);
        });
  };

  const createParamObjectForWorklist = (psd, updatedTitle, updatedView, filterApplied, value, pageObjVal, multipleFilterApplied) => {
    let patientSearchDTO = {};
    SessionStorageUtil.setObj(RECENT_QUERY_SETTINGS_KEY, LAST_QUERY_SETTINGS_KEY);
    SessionStorageUtil.setObj(LAST_QUERY_SETTINGS_KEY, {
      patientSearchDTO: psd,
      view: updatedView,
      title: updatedTitle,
    });
    if (!filterApplied || (filterApplied && multipleFilterApplied)) {
      psd.pageSize = 5;
    }
    let defaultFilterPresent = false;
    let filterParams = psd.filterParams;
    let filterParamsNew = [];
    for (const filterParam of filterParams) {
      const obj = { paramName: "", paramValue: "" };
      obj.paramName = filterParam.paramName;
      if (filterParam.paramName === "missedOppStatus") {
        obj.paramValue = [value];
        defaultFilterPresent = true;
      } else {
        obj.paramValue = filterParam.paramValue;
      }
      filterParamsNew.push(obj);
    }
    if (!defaultFilterPresent) {
      let defaultFilterParam = {
        paramName: "missedOppStatus",
        paramValue: [value],
        comparison: "eq",
        displayValue: [],
      };
      filterParamsNew.push(defaultFilterParam);
    }
    if (cardViewData?.[pageObjVal]?.totalSize) {
      patientSearchDTO.previousTotalSize = cardViewData[pageObjVal].totalSize;
    }
    patientSearchDTO.filterParams = filterParamsNew;
    patientSearchDTO.pageNumber = psd.pageNumber;
    patientSearchDTO.quickListName = "MISSED_OPPORTUNITIES";
    patientSearchDTO.quickFilterName = psd.quickFilterName;
    patientSearchDTO.pageSize = psd.pageSize
    return patientSearchDTO;
  };

  useEffect(() => {
    if (listViewActionObj && listViewData && listViewData.pageNumber === pageNumber) {
      if (view === VIEW.list) {
        copyToPatientListVariables(listViewData.data);
      }
      setListViewLoadingData(false);
    }
  // List response hydration is intentionally keyed to the response payload only.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listViewData]);

  useEffect(() => {
    if (activeFilterView) {
      query(new PatientSearchDTO(filterParams, sortParams, pageNumber, pageSize, quickListType, totalSize), title, view);
    }
  // Active filter view is the explicit trigger for this query replay.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFilterView]);

  const queryMissedOpportunities = (patientSearchDTO, updatedTitle, updatedView) => {
    setSelectedFilter([]);
    const missedOppStatusFilter = patientSearchDTO.filterParams.find(
      (filterParam) => filterParam.paramName === "missedOppStatus"
    );

    if (!missedOppStatusFilter) {
      patientSearchDTO.pageSize = 5;
      callworklistquery(patientSearchDTO, updatedTitle, updatedView, false);
      return;
    }

    if (patientSearchDTO.pageSize < 20) {
      patientSearchDTO.pageSize = 20;
    }

    const paramValue = missedOppStatusFilter.paramValue;
    const multipleMissedOppFilters = paramValue.length > 1;
    setFilterApplied(true);
    setMultipleFilterApplied(multipleMissedOppFilters);
    callworklistquery(patientSearchDTO, updatedTitle, updatedView, true, paramValue, multipleMissedOppFilters);
  };

  const queryCardView = (patientSearchDTO) => {
    cardViewActionObj
      .fetchData(patientSearchDTO)
      .then((res) => {
        if (res.data) {
          const pageObject = {
            pageNumber: patientSearchDTO.pageNumber,
            data: res.data,
          };
          setCardViewData(pageObject);
        }
        setCanceled(false);
      })
      .catch((err) => {
        if (err?.message !== "cancel by user") {
          setCanceled(false);
        }
        setLoadingData(false);
      });
  };

  const queryListView = (patientSearchDTO) => {
    listViewActionObj
      .fetchData(patientSearchDTO)
      .then((res) => {
        if (res.data) {
          const pageObject = {
            pageNumber: patientSearchDTO.pageNumber,
            data: res.data,
          };
          setListViewData(pageObject);
        }
        setCanceled(false);
      })
      .catch((err) => {
        if (err?.message !== "cancel by user") {
          setCanceled(false);
        }
        setListViewLoadingData(false);
      });
  };

  const query = async (patientSearchDTO, updatedTitle, updatedView) => {
    setLoadingData(true);
    setPageNumber(patientSearchDTO.pageNumber);
    SessionStorageUtil.setObj(RECENT_QUERY_SETTINGS_KEY, LAST_QUERY_SETTINGS_KEY);
    SessionStorageUtil.setObj(LAST_QUERY_SETTINGS_KEY, {
      patientSearchDTO: patientSearchDTO,
      view: updatedView,
      title: updatedTitle,
    });
    if (listViewActionObj) {
      setListViewLoadingData(true);
    }

    if (quickListType === "MISSED_OPPORTUNITIES") {
      queryMissedOpportunities(patientSearchDTO, updatedTitle, updatedView);
    } else {
      queryCardView(patientSearchDTO);
    }
    if (listViewActionObj) {
      queryListView(patientSearchDTO);
    }
  };


  const fetchData = async (filterParams, quicklistName, title, view) => {
    query(new PatientSearchDTO(filterParams, sortParams, pageNumber, pageSize, quicklistName), title, view);
  };

  const getSavedQuicklistObj = (restoreObject) => {
    let quicklistObj = SessionStorageUtil.getObj(LAST_QUERY_SETTINGS_KEY);
    if (restoreObject?.recentKey === LAST_QUERY_SETTINGS_KEY) {
      quicklistObj = restoreObject.quickListObj;
      SessionStorageUtil.setObj(LAST_QUERY_SETTINGS_KEY, quicklistObj);
    }
    return quicklistObj;
  };

  const loadSavedQuery = (quicklistObj) => {
    if (defaultSortParamsProp) {
      quicklistObj.patientSearchDTO.sortParams = defaultSortParamsProp;
    }
    //load from back button
    setTitle(quicklistObj.title);
    setView(quicklistObj.view);
    setDefaultFilterParamHelper(quicklistObj.patientSearchDTO.filterParams);
    setSortParams(quicklistObj.patientSearchDTO.sortParams);
    query(quicklistObj.patientSearchDTO, quicklistObj.title, quicklistObj.view);
  };

  const loadCustomList = () => {
    axios
      .get(CUSTOM_LIST_URL + "?id=" + quicklistId, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setDefaultFilterParamHelper(response.data.patientRequestDTO.filterParams);
        setTitle(response.data.name);
        fetchData(response.data.patientRequestDTO.filterParams, response.data.quickList, response.data.name, view);
      })
      .catch((error) => {
        setModalTitle("Error");
        setModalSize("lg");
        setModalMessage(error.response?.data?.message ?? error.message);
        setLoadingData(false);
      });
  };

  const loadCustomWorklist = () => {
    axios
      .get(WORKLIST_URL + "?id=" + quicklistId, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .catch(() => {
        setLoadingData(false);
      });

    const valuesAndDisplayValues = [
      {
        text: customWorklistName,
        value: quicklistId,
      },
    ];
    const filterParam = new FilterParam(
      "Member Worklist",
      "eq",
      valuesAndDisplayValues,
      (x) => x.value,
      (x) => x.text
    );
    const tempFilterParams = Object.assign([], filterParams);
    tempFilterParams.push(filterParam);
    setDefaultFilterParamHelper(tempFilterParams);
    setTitle(customWorklistName);
    fetchData(tempFilterParams, "ALL_PATIENTS", customWorklistName, view);
    setFilterParams(tempFilterParams);
  };

  const loadPatientOverview = () => {
    const patientFilters = preventiveCarePatientFilterParams;
    axios
      .get(process.env.REACT_APP_REST_API_BASE_URL + `/v1/patients/overview/summary?patientId=${quicklistId}`, {
        headers: {},
      })
      .then((response) => {
        patientFilters[0].displayValue[0] = response.data.lastName;
        patientFilters[0].displayValue[1] = response.data.firstName;
        patientFilters[0].paramValue[0] = response.data.lastName + ", " + response.data.firstName;
        patientFilters[1].displayValue[0] = "On " + formatDate(response.data.dateOfBirth);
        patientFilters[1].paramValue[0] = formatDate(response.data.dateOfBirth);

        setDefaultFilterParamHelper(patientFilters);
        setTitle(titleProp);
        fetchData(patientFilters, quickListType, titleProp, view);
      })
      .catch(() => {
        setLoadingData(false);
      });
  };

  const loadDefaultQuickList = () => {
    setTitle(titleProp);
    setDefaultFilterParamHelper(defaultFilterParamsProp);
    if (defaultSortParamsProp) {
      setSortParams(defaultSortParamsProp);
      query(
        new PatientSearchDTO(defaultFilterParamsProp, defaultSortParamsProp, pageNumber, pageSize, quickListType),
        titleProp,
        view
      );
      return;
    }
    fetchData(defaultFilterParamsProp, quickListType, titleProp, view);
  };


  useEffect(() => {
    //restore from last timeout override
    const restoreObject = SessionStorageUtil.getObj(CE_RESTORE_OBJ);
    const quicklistObj = getSavedQuicklistObj(restoreObject);
    const useLastQuery = SessionStorageUtil.getObj(LAST_QUERY_USAGE_KEY);
    SessionStorageUtil.setObj(LAST_QUERY_USAGE_KEY, null);
    if (restoreObject) {
      SessionStorageUtil.setObj(CE_RESTORE_OBJ, null);
    }

    if ((restoreObject || useLastQuery) && quicklistObj?.patientSearchDTO) {
      loadSavedQuery(quicklistObj);
      return;
    }
    if (hasNumericQuicklistId(quicklistId)) {
      loadCustomList();
      return;
    }
    if (quicklistId?.includes("customWorklist")) {
      loadCustomWorklist();
      return;
    }
    if (quicklistId?.includes("data")) {
      loadPatientOverview();
      return;
    }

    loadDefaultQuickList();
  // Initial quick-list routing is intentionally keyed to the route quicklist id.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quicklistId]);

  const reloadPatientView = () => {
    fetchData(filterParams, quickListType, titleProp, view);
  };

  const summary = () => {
    axios
      .get(SUMMARY_URL, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setShowPrintSpinner(false);
        setShowExportSpinner(false);
        setModalTitle("Export Summary");
        setModalSize("lg");
        setModalMessage(<ExportSummary exportSummary={response.data} />);
      })
      .catch((error) => {
        setShowPrintSpinner(false);
        setShowExportSpinner(false);
        setModalTitle("Error");
        setModalMessage(error.response?.data?.message ?? error.message);
        setLoadingData(false);
      });
  };

  const exportPatients = () => {
    setShowExportSpinner(true);
    const filterData = new PatientSearchDTO(filterParams, sortParams, pageNumber, pageSize, quickListType);
    let criteria = {};
    criteria.patientRequest = filterData;
    criteria.selectedItems = Array.from(selectedPatients, ([key, value]) => value.id);
    criteria.quickList = quickListType;
    axios
      .post(exportPatientsUrl, criteria, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        summary();
      })
      .catch((error) => {
        setShowExportSpinner(false);
        setModalTitle("Error");
        setModalMessage(error.response?.data?.message ?? error.message);
      });
  };

  const selectPatient = (patient, selected) => {
    const selectedPatientsCopy = new Map(selectedPatients);
    if (selected) {
      selectedPatientsCopy.set(patient.id, patient);
    } else {
      selectedPatientsCopy.delete(patient.id);
    }
    setSelectedPatients(selectedPatientsCopy);
  };
  const selectPatients = (patients, selected) => {
    const selectedPatientsCopy = new Map(selectedPatients);
    if (selected) {
      for (const patient of patients) {
        selectedPatientsCopy.set(patient.id, patient);
      }
    } else {
      for (const patient of patients) {
        selectedPatientsCopy.delete(patient.id);
      }
    }
    setSelectedPatients(selectedPatientsCopy);
  };

  const isPatientSelected = (patient) => {
    return selectedPatients.has(patient.id);
  };

  const removePatients = async () => {
    let patientIds = [];
    selectedPatients.forEach((patient, id) => {
      patientIds.push(id);
    });
    await removePatientsFromList(patientIds);
    setRemoveModal(false);
    query(new PatientSearchDTO(filterParams, sortParams, pageNumber, pageSize, quickListType), title, view);
  };

  const closeEvidenceModal = () => {
    query(new PatientSearchDTO(filterParams, sortParams, pageNumber, pageSize, quickListType), title, view);
  };

  const updateParent = (updatedRef, sourceType) => {
    let newState = patientsList.default;
    if (sourceType === "ManageEvidence") {
      return;
    }
    if (sourceType === "SubmitRecentVisit") {
      newState.forEach((pat, patI) => {
        if (pat.id === updatedRef.patientId) {
          newState[patI].nextVisit = updatedRef.nextVisit;
          newState[patI].recentVisitStatus = updatedRef.recentVisitStatus;
          newState[patI].nextVisitInfo = updatedRef.nextVisitInfoDesc;
          newState[patI].recentVisit = updatedRef.recentVisit;
          newState[patI].recentVisitInfo = updatedRef.recentVisitInfoDesc;
          let patientListSectioned = {
            awaitingChart: [],
            rejected: []
          };
          patientListSectioned.default = [...newState];
          setPatientsList(patientListSectioned);
        }
      });
    } else if (updatedRef) {
      let patIndex = null;
      let refIndex = null;
      newState.forEach((pat, patI) => {
        if (pat.id === updatedRef.patient.id) {
          patIndex = patI;
          pat.referralDtoList.forEach((ref, refI) => {
            if (ref.id === updatedRef.referralId) {
              refIndex = refI;
            }
          });
        }
      });
      if (newState[patIndex].referralDtoList[refIndex].status !== updatedRef.status) {
        newState[patIndex].referralDtoList[refIndex].status = updatedRef.status;
        let patientListSectioned = {
          awaitingChart: [],
          rejected: [],
        };
        patientListSectioned.default = [...newState];
        setPatientsList(patientListSectioned);
      }
    }
  };
  const appointmentCancelled = () => {
    query(new PatientSearchDTO(filterParams, sortParams, pageNumber, pageSize, quickListType), title, view);
  };

  const onShowAssignCareManagerModal = () => undefined;
  const hasDefaultPatients = patientsList.default?.length > 0 && patientsList.default[0] !== "Empty";
  const shouldShowNoPatients = !loadingData && !listViewLoadingData;
  const nonMissedOpportunitiesContent = hasDefaultPatients ? (
    <ListView
      updatePatients={setPatientsList}
      patientList={patientsList}
      workListStatusSize={[
        awaitingChartPatientSize,
        rejectedPatientSize
      ]}
      activeFilterView={activeFilterView}
      quickListType={quickListType}
      loadingData={loadingData}
      listViewLoadingData={listViewLoadingData}
      handleChangeCheckBox={selectPatient}
      handleAllPatientsCheckbox={selectPatients}
      isPatientSelected={isPatientSelected}
      quicklistId={quicklistId}
      returnToMyPatientsUrl={returnToMyPatientsUrl}
      updateParent={updateParent}
      closeEvidenceModal={closeEvidenceModal}
      reloadPatientView={reloadPatientView}
      onShowAssignCareManagerModal={onShowAssignCareManagerModal}
      careManagementActions={careManagementActions}
      titleProp={titleProp}
      appointmentCancelled={appointmentCancelled}
      handlePatientGapStatusChange={handlePatientGapStatusChange}
      handleFilterChange={handleFilterChange}
      filterParams={filterParams}
      pageNumber={pageNumber}
      filterApplied={filterApplied}
      selectedFilter={selectedFilter}
    />
  ) : (
    shouldShowNoPatients && (
      <Row>
        <Col>
          <Card>
            <Card.Body>
              <Card.Text id={`${componentName}-NoPatients`}>
                {canceled ? "Loading..." : "No Patients Found"}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    )
  );

  return (
    <Container fluid className="py-3">
      <Helmet>
        <title>{title} | CareEmpower</title>
      </Helmet>
      <Modals
        show={removeModal}
        onHide={() => setRemoveModal(false)}
        title="Remove Member(s) from organization's patient list"
        size="lg"
        onCreate={removePatients}
        hideClickButton={false}
        showExtraButton={false}
        hideFooter={false}
        completeBtn="Save"
        completeBtnId={`${componentName}-saveButton`}
        body={<RemoveModalBody patientsSelected={Array.from(selectedPatients, ([key, value]) => value)} />}
      />

      {quickListType === "MISSED_OPPORTUNITIES" ? (
        <div>
          <Row>
            <Col>
              <FilterGroupNew
                filters={filters}
                handleChange={handleFilterChange}
                totalSize={totalSize}
                defaultFilterParams={defaultFilterParams}
                filterParams={filterParams}
                sortParams={sortParams}
                pageNumber={pageNumber}
                pageSize={pageSize}
                quickListType={quickListType}
                setModalMessage={setModalMessage}
                setModalSize={setModalSize}
                setModalTitle={setModalTitle}
                customWorklistName={customWorklistName}
                additionalValidation={qlsSettings.additionalFilterValidation}
              />
            </Col>
            <Col md={2} className="text-end">
              {(loadingData || listViewLoadingData) && (
                <SpinnerLoading />
              )}
            </Col>
          </Row>
          {(!isEmpty(patientsList.awaitingChart) ||
            !isEmpty(patientsList.rejected)
          ) && (
            <Row className="mb-3">
              <Col>
                {!isEmpty(pageCount) && (
                  <Badge pill bg="light" id={`${componentName}-PatientCount`} className="border text-dark">
                    {pageCount.toLocaleString()} Patients
                  </Badge>
                )}
                {(showExportSpinner || showPrintSpinner) && (
                  <SpinnerLoading />
                )}
              </Col>
              <Col className="text-start text-sm-end mt-sm-0">
                {filterApplied && !multipleFilterApplied && (
                  <div className="d-inline-block me-2 align-top">
                    <select
                      className="form-select"
                      id={`${componentName}-ResultsPerPage`}
                      disabled={!filterApplied}
                      onChange={(e) => handleFilterPageSize(e)}
                    >
                      <option value="20-Results" selected disabled hidden>
                        20 Results Per Page
                      </option>
                      <option value="50-Results">50 Results Per Page</option>
                      <option value="20-Results">20 Results Per Page</option>
                    </select>
                  </div>
                )}

                <div className="d-inline-block ms-0 ms-sm-2">
                  <CustomPagination
                    paginateButClicked={handlePaginationChange}
                    MAX_PAGE={Math.ceil(totalSize / pageSize)}
                    pageNumber={Math.ceil(pageNumber)}
                  />
                </div>

                {exportPatientsUrl != null && (
                  <Dropdown className="d-inline-block align-top">
                    <Dropdown.Toggle id={`${componentName}-Export`} variant="link" className="border-0">
                      <i className="fa-solid fa-ellipsis text-dark"></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu variant="dark">
                      <Dropdown.Item
                        id={`${componentName}-ExportCSV`}
                        disabled={
                          isEmpty(totalSize) ||
                          (totalSize > PRINT_THRESHOLD && selectedPatients.size === 0) ||
                          !filterApplied ||
                          multipleFilterApplied
                        }
                        onClick={() => exportPatients()}
                      >
                        Export to CSV
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </Col>
            </Row>
            )}
          <ListView
            updatePatients={setPatientsList}
            patientList={patientsList}
            workListStatusSize={[
              awaitingChartPatientSize,
              rejectedPatientSize
            ]}
            activeFilterView={activeFilterView}
            quickListType={quickListType}
            loadingData={loadingData}
            listViewLoadingData={listViewLoadingData}
            handleChangeCheckBox={selectPatient}
            handleAllPatientsCheckbox={selectPatients}
            isPatientSelected={isPatientSelected}
            quicklistId={quicklistId}
            returnToMyPatientsUrl={returnToMyPatientsUrl}
            updateParent={updateParent}
            closeEvidenceModal={closeEvidenceModal}
            reloadPatientView={reloadPatientView}
            onShowAssignCareManagerModal={onShowAssignCareManagerModal}
            careManagementActions={careManagementActions}
            titleProp={titleProp}
            appointmentCancelled={appointmentCancelled}
            handlePatientGapStatusChange={handlePatientGapStatusChange}
            handleFilterChange={handleFilterChange}
            filterParams={filterParams}
            pageNumber={pageNumber}
            filterApplied={filterApplied}
            selectedFilter={selectedFilter}
          />
        </div>
      ) : (
        nonMissedOpportunitiesContent
      )}

      <Modals
        show={modalMessage != null}
        onHide={() => setModalMessage(null)}
        title={modalTitle}
        size={modalSize || "md"}
        hideClickButton={true}
        showExtraButton={false}
        hideFooter={false}
        closeBtnId={`${componentName}-closeButton`}
        body={modalMessage}
      />
    </Container>
  );
};

QuickLists.propTypes = {
  titleProp: PropTypes.string,
  filters: PropTypes.array,
  pageNumberProp: PropTypes.number,
  pageSizeProp: PropTypes.number,
  totalSizeProp: PropTypes.number,
  defaultFilterParamsProp: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  defaultSortParamsProp: PropTypes.array,
  exportPatientsUrl: PropTypes.string,
  quickListType: PropTypes.string,
  displayExtraRows: PropTypes.bool,
  quickListId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  cardViewActionObj: PropTypes.shape({
    fetchData: PropTypes.func,
    copyMap: PropTypes.object,
  }),
  unScheduledActionObj: PropTypes.shape({
    fetchData: PropTypes.func,
    copyMap: PropTypes.object,
  }),
  listViewActionObj: PropTypes.shape({
    fetchData: PropTypes.func,
    copyMap: PropTypes.object,
  }),
  startingView: PropTypes.string,
  listViewColumns: PropTypes.array,
  careManagementActions: PropTypes.array,
};

export { QuickLists, VIEW, LAST_QUERY_SETTINGS_SUFFIX, RECENT_QUERY_SETTINGS_KEY };
